import { ArrowRight } from "lucide-react";
import { useTheme } from "../context/ThemeContext";
import PalWelcome from "./pal/PalWelcome";

/**
 * Keynote-style opening. Full-bleed. One headline, one subline, one action.
 * Airline variant folds in tastefully as a small chip and secondary line.
 */
const SlideWelcome = ({ airline }) => {
  const { isDark } = useTheme();
  const isPrivate = airline && airline.id !== "default";

  const accent = airline?.brandColor || "#F2A900";

  const primaryLabel = isPrivate ? `Begin ${airline.name}'s pitch` : "Explore Aeroplay";

  const onPrimary = () => {
    // Trigger arrow-right to advance to the next slide
    window.dispatchEvent(new KeyboardEvent("keydown", { key: "ArrowRight" }));
  };

  if (isPrivate && airline.content?.welcome) return <PalWelcome airline={airline} onPrimary={onPrimary} />;

  return (
    <div className="w-full">
      <div className="mx-auto max-w-[1220px] px-8 lg:px-12 py-10 lg:py-16 flex flex-col items-start">
        <div className="mb-8 flex items-center gap-3">
          <span className={`k-eyebrow ${isDark ? "text-white/50" : "text-black/45"}`}>
            {isPrivate ? "Private Pitch" : "A premium content service provider"}
          </span>
          {isPrivate && airline.logo && (
            <span
              className={`inline-flex items-center gap-2 pl-2 pr-3 py-1 rounded-full text-[12px] font-medium ${
                isDark ? "bg-white/[0.06] text-white/80 border border-white/10" : "bg-black/[0.04] text-black/75 border border-black/10"
              }`}
            >
              <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: accent }} />
              For {airline.name}
            </span>
          )}
        </div>

        <h1
          className={`k-h1 max-w-[14ch] ${isDark ? "text-white" : "text-[#1d1d1f]"}`}
          data-testid="welcome-headline"
        >
          Content, operations
          <br />
          and passenger experience.
          <span className="block" style={{ color: accent }}>Made effortless.</span>
        </h1>

        <p
          className={`k-lead mt-8 max-w-[52ch] ${isDark ? "text-white/70" : "text-black/60"}`}
          data-testid="welcome-subline"
        >
          Aeroplay connects studio-grade content, an AI-driven operating system
          and cabin-ready experiences into one story your passengers actually
          feel.
        </p>

        <div className="mt-12 flex items-center gap-3">
          <button
            onClick={onPrimary}
            data-testid="welcome-primary"
            className="inline-flex items-center gap-2 h-12 px-6 rounded-full text-[15px] font-semibold transition-all hover:scale-[1.02] active:scale-[0.99]"
            style={{
              backgroundColor: isDark ? "#ffffff" : "#1d1d1f",
              color: isDark ? "#0b0b0d" : "#ffffff",
            }}
          >
            {primaryLabel} <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SlideWelcome;
